/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentCategory } from './TournamentCategory';
import {
    TournamentCategoryFromJSON,
    TournamentCategoryFromJSONTyped,
    TournamentCategoryToJSON,
    TournamentCategoryToJSONTyped,
} from './TournamentCategory';
import type { ClassificationPosition } from './ClassificationPosition';
import {
    ClassificationPositionFromJSON,
    ClassificationPositionFromJSONTyped,
    ClassificationPositionToJSON,
    ClassificationPositionToJSONTyped,
} from './ClassificationPosition';

/**
 * 
 * @export
 * @interface TournamentClassification
 */
export interface TournamentClassification {
    /**
     * 
     * @type {string}
     * @memberof TournamentClassification
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentClassification
     */
    tournamentId?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentClassification
     */
    categoryId?: string;
    /**
     * 
     * @type {TournamentCategory}
     * @memberof TournamentClassification
     */
    category?: TournamentCategory;
    /**
     * 
     * @type {string}
     * @memberof TournamentClassification
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentClassification
     */
    totalPositions?: number;
    /**
     * 
     * @type {Array<ClassificationPosition>}
     * @memberof TournamentClassification
     */
    positions?: Array<ClassificationPosition>;
    /**
     * 
     * @type {Date}
     * @memberof TournamentClassification
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the TournamentClassification interface.
 */
export function instanceOfTournamentClassification(value: object): value is TournamentClassification {
    return true;
}

export function TournamentClassificationFromJSON(json: any): TournamentClassification {
    return TournamentClassificationFromJSONTyped(json, false);
}

export function TournamentClassificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentClassification {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tournamentId': json['tournamentId'] == null ? undefined : json['tournamentId'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'category': json['category'] == null ? undefined : TournamentCategoryFromJSON(json['category']),
        'name': json['name'] == null ? undefined : json['name'],
        'totalPositions': json['totalPositions'] == null ? undefined : json['totalPositions'],
        'positions': json['positions'] == null ? undefined : ((json['positions'] as Array<any>).map(ClassificationPositionFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function TournamentClassificationToJSON(json: any): TournamentClassification {
    return TournamentClassificationToJSONTyped(json, false);
}

export function TournamentClassificationToJSONTyped(value?: TournamentClassification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tournamentId': value['tournamentId'],
        'categoryId': value['categoryId'],
        'category': TournamentCategoryToJSON(value['category']),
        'name': value['name'],
        'totalPositions': value['totalPositions'],
        'positions': value['positions'] == null ? undefined : ((value['positions'] as Array<any>).map(ClassificationPositionToJSON)),
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
    };
}

